import { APIService } from '../api/APIService'

import {
  ADD_AGREEMENT,
  DELETE_AGREEMENT,
  EDIT_AGREEMENT,
  FETCH_AGREEMENT,
  FETCH_AGREEMENT_BY_REF,
  FETCH_AGREEMENTS
} from './types/actions.type'

import {
  SET_AGREEMENTS_DATA,
  SET_HAS_AGREEMENTS,
  SET_LOADING,
  SET_ERROR
} from './types/mutations.type'

const api = new APIService()

const state = {
  agreement: {},
  agreements: [],
  hasAgreements: false,
  errors: null,
  isLoading: true
}

const getters = {
  getAgreementData(state) {
    return state.agreement
  },
  getAgreementsData(state) {
    return state.agreements
  },
  hasAgreementsData(state) {
    return state.hasAgreements
  },
  isAgreementsRequestInProgress(state){
    return state.isLoading
  },
  fetchAgreementsError(state) {
    return state.errors
  }
}

const actions = {
  [FETCH_AGREEMENT](context, id) {
    context.commit(SET_LOADING, true)
    return new Promise((resolve, reject) => {
      api.getBusinessAgreementsByID(id).then(data => {
        context.commit(SET_LOADING, false)
        if(data.statusCode === 400) {
          context.commit(SET_ERROR, data.message)
        } else {
          resolve(data)
        }
      }).catch(err => {
        context.commit(SET_ERROR, err)
        reject(err)
      })
    })
  },
  [FETCH_AGREEMENT_BY_REF](context, ref) {
    context.commit(SET_LOADING, true)
    return new Promise((resolve, reject) => {
      api.getBusinessAgreementsByRefCode(ref).then(data => {
        context.commit(SET_LOADING, false)
        if(data.statusCode === 400) {
          context.commit(SET_ERROR, data.message)
        } else {
          resolve(data)
        }
      }).catch(err => {
        context.commit(SET_ERROR, err)
        reject(err)
      })
    })
  },
  [FETCH_AGREEMENTS](context, id) {
    context.commit(SET_LOADING, true)
    return new Promise((resolve, reject) => {
      api.getBusinessAgreementsByUserID(id).then(data => {
        context.commit(SET_LOADING, false)
        if(data.statusCode === 400) {
          context.commit(SET_ERROR, data.message)
        } else {
          context.commit(SET_AGREEMENTS_DATA, data)
          if(data.length !== 0) context.commit(SET_HAS_AGREEMENTS, true)
          else context.commit(SET_HAS_AGREEMENTS, false)
        }
      }).catch(err => {
        context.commit(SET_ERROR, err)
        reject(err)
      })
    })
  },
  [ADD_AGREEMENT](context, fields) {
    context.commit(SET_LOADING, true)
    return new Promise((resolve, reject) => {
      api.createAgreement(fields).then(data => {
        context.commit(SET_LOADING, false)
        resolve(data)
      }).catch(err => {
        context.commit(SET_ERROR, err)
      })
    })
  },
  [EDIT_AGREEMENT](context, {id, fields}) {
    context.commit(SET_LOADING, true)
    return new Promise((resolve, reject) => {
      api.updateAgreement(id, fields).then(data => {
        context.commit(SET_LOADING, false)
        resolve(data)
      }).catch(err => {
        context.commit(SET_ERROR, err)
        reject(err)
      })
    })
  },
  [DELETE_AGREEMENT](context, id) {
    context.commit(SET_LOADING, true)
    return new Promise((resolve, reject) => {
      api.deleteAgreement(id).then(data => {
        context.commit(SET_LOADING, false)
        if(data.statusCode === 400) {
          context.commit(SET_ERROR, data.message)
        } else {
          resolve(data)
        }
      }).catch(err => {
        context.commit(SET_ERROR, err)
        reject(err)
      })
    })
  }
}

const mutations = {
  [SET_ERROR](state, value) {
    state.errors = value
  },
  [SET_LOADING](state, value) {
    state.isLoading = value
  },
  [SET_AGREEMENTS_DATA](state, value) {
    state.agreements = value
  },
  [SET_HAS_AGREEMENTS](state, value) {
    state.hasAgreements = value
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/agreements.module.js